import { useQuery } from "@tanstack/react-query";
import Axios from "axios";

export const useSummaryContent = (
  contentUrl: string | undefined,
  enabled = true
) => {
  return useQuery({
    queryKey: ["summaryContent", contentUrl],
    queryFn: async () => {
      if (!contentUrl) {
        return null;
      }
      const { data } = await Axios.get<string>(contentUrl);
      return data;
    },
    enabled: !!contentUrl && enabled,
    staleTime: Infinity,
  });
};
